import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";
import { getOrgBackend } from "../../../../app/backend";

export type PermissionAssignmentInfoDto = {
  costCenterUnitIds: string[];
  targetEmployeeQuota: number;
  targetSupervisorQuota: number;
};

export function useRemotePostMonitoringQuota() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, PermissionAssignmentInfoDto>({
    url: `${getOrgBackend()}/permission-assignment-quota`,
    key: ["permission-assignment-quota"],
    method: "post",
    snackbarTextOnSuccess: t("Successfully edited the quota"),
    snackbarTextOnFail: t("There was a server error")
  });
}
